module.exports = __webpack_public_path__ + "img/item7-2.d7bb7d69.png";